import { checkProfanity } from "glin-profanity";

const CUSTOM_BLOCKED_WORDS = [
  "xxx",
  "18plus",
  "adultword1",
  "f@ck",
  "f u c k",
  "sh1t",
  "s h i t",
  "b i t c h",
];

let restrictedWords: string[] = [...CUSTOM_BLOCKED_WORDS];

export const setRestrictedWords = (words?: string[] | null) => {
  restrictedWords = Array.isArray(words) && words.length > 0 ? words : [...CUSTOM_BLOCKED_WORDS];
};

export const isBadWord = (text: string) => {
  const { containsProfanity } = checkProfanity(text, {
    languages: ["english"],
    customWords: restrictedWords,
  });

  return containsProfanity;
};
